import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Analytics } from "@vercel/analytics/react";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Work from "@/pages/Work";
import About from "@/pages/About";
import ServicesOverview from "@/pages/ServicesOverview";
import ServiceDetail from "@/pages/ServiceDetail";
import IndustriesOverview from "@/pages/IndustriesOverview";
import IndustryDetail from "@/pages/IndustryDetail";
import Process from "@/pages/Process";
import Contact from "@/pages/Contact";
import ProjectDetail from "@/pages/ProjectDetail";
import TicTacToe from "@/pages/TicTacToe";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/work/:slug" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<ServicesOverview />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/industries" element={<IndustriesOverview />} />
          <Route path="/industries/:slug" element={<IndustryDetail />} />
          <Route path="/process" element={<Process />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/game" element={<TicTacToe />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="light"
          toastOptions={{
            style: {
              background: "var(--carbon-black)",
              color: "var(--bright-snow)",
              border: "1px solid var(--gunmetal)",
              borderRadius: "12px",
              fontFamily: "var(--font-body)",
            },
          }}
        />
        <Analytics />
      </BrowserRouter>
    </div>
  );
}

export default App;
